var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "fastfood-view" },
    [
      _c("div", { staticClass: "ff-main" }, [
        _c(
          "div",
          { staticClass: "ff-cats" },
          [
            _c(
              "div",
              {
                staticClass: "ff-cat",
                class: { active: _vm.activeCategory === 0 },
                on: {
                  click: function ($event) {
                    return _vm.switchCategory(0)
                  },
                },
              },
              [_vm._v("全部")]
            ),
            _vm._l(_vm.flatCategories, function (c) {
              return _c(
                "div",
                {
                  key: c.id,
                  staticClass: "ff-cat",
                  class: { active: _vm.activeCategory === c.id },
                  on: {
                    click: function ($event) {
                      return _vm.switchCategory(c.id)
                    },
                  },
                },
                [_vm._v(_vm._s(c.name))]
              )
            }),
          ],
          2
        ),
        _c(
          "div",
          { staticClass: "ff-goods" },
          [
            _c(
              "div",
              { staticClass: "ff-goods-head" },
              [
                _c("a-input-search", {
                  attrs: { placeholder: "搜索菜品名称", allowClear: "" },
                  on: { search: _vm.loadMenu },
                  model: {
                    value: _vm.searchKey,
                    callback: function ($$v) {
                      _vm.searchKey = $$v
                    },
                    expression: "searchKey",
                  },
                }),
              ],
              1
            ),
            _vm.menuLoading
              ? _c("a-icon", {
                  staticClass: "ff-loading",
                  attrs: { type: "loading" },
                })
              : _c(
                  "div",
                  { staticClass: "ff-grid" },
                  _vm._l(_vm.goods, function (g) {
                    return _c(
                      "div",
                      {
                        key: g.id,
                        staticClass: "ff-card",
                        class: { soldout: _vm.isSoldOut(g) },
                        on: {
                          click: function ($event) {
                            return _vm.onGoodsClick(g)
                          },
                        },
                      },
                      [
                        _c("div", { staticClass: "ff-card-img" }, [
                          g.imgName
                            ? _c("img", {
                                attrs: { src: _vm.imgUrl(g.imgName), alt: "" },
                              })
                            : _c("span", { staticClass: "ff-img-holder" }, [
                                _vm._v(_vm._s(_vm.firstChar(g))),
                              ]),
                          _vm.isSoldOut(g)
                            ? _c("span", { staticClass: "ff-soldout" }, [
                                _vm._v("估清"),
                              ])
                            : _vm._e(),
                        ]),
                        _c(
                          "div",
                          {
                            staticClass: "ff-card-name",
                            attrs: { title: g.materialName },
                          },
                          [_vm._v(_vm._s(g.materialName))]
                        ),
                        _c("div", { staticClass: "ff-card-price" }, [
                          _vm._v("¥" + _vm._s(_vm.fmt(g.minPrice))),
                        ]),
                      ]
                    )
                  }),
                  0
                ),
            !_vm.menuLoading && _vm.goods.length === 0
              ? _c("div", { staticClass: "ff-goods-empty" }, [
                  _vm._v("该分类暂无在售菜品"),
                ])
              : _vm._e(),
          ],
          1
        ),
      ]),
      _c("div", { staticClass: "ff-side" }, [
        _c("div", { staticClass: "ff-parked" }, [
          _c(
            "div",
            {
              staticClass: "ff-parked-head",
              on: {
                click: function ($event) {
                  _vm.parkedExpanded = !_vm.parkedExpanded
                },
              },
            },
            [
              _c("span", [_vm._v("挂单（" + _vm._s(_vm.parked.length) + "）")]),
              _c("a-icon", {
                attrs: { type: _vm.parkedExpanded ? "up" : "down" },
              }),
            ],
            1
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.parkedExpanded,
                  expression: "parkedExpanded",
                },
              ],
              staticClass: "ff-parked-list",
            },
            [
              _vm._l(_vm.parked, function (p) {
                return _c(
                  "div",
                  {
                    key: p.id,
                    staticClass: "ff-parked-card",
                    on: {
                      click: function ($event) {
                        return _vm.resumeParked(p)
                      },
                    },
                  },
                  [
                    _c("div", { staticClass: "fp-row" }, [
                      _c("span", { staticClass: "fp-no" }, [
                        _vm._v(_vm._s(p.order_no)),
                      ]),
                      _c("span", { staticClass: "fp-amount" }, [
                        _vm._v("¥" + _vm._s(_vm.fmt(p.total_amount))),
                      ]),
                    ]),
                    _c("div", { staticClass: "fp-time" }, [
                      _vm._v(_vm._s(p.create_time) + " · 点击取单恢复"),
                    ]),
                  ]
                )
              }),
              _vm.parked.length === 0
                ? _c("div", { staticClass: "fp-empty" }, [_vm._v("暂无挂单")])
                : _vm._e(),
            ],
            2
          ),
        ]),
        _c("div", { staticClass: "ff-cart" }, [
          _c("div", { staticClass: "ff-cart-title" }, [
            _c("span", [_vm._v("当前账单")]),
            _vm.cart.length
              ? _c(
                  "a",
                  {
                    staticClass: "ff-clear",
                    on: {
                      click: function ($event) {
                        _vm.cart = []
                      },
                    },
                  },
                  [_vm._v("清空待下单")]
                )
              : _vm._e(),
          ]),
          _c(
            "div",
            { staticClass: "ff-cart-scroll" },
            [
              _vm.orderItems.length
                ? [
                    _c("div", { staticClass: "ff-group-label" }, [
                      _vm._v("已下单（金额为后端计价）"),
                    ]),
                    _vm._l(_vm.orderItems, function (it) {
                      return _c(
                        "div",
                        {
                          key: it.id,
                          staticClass: "ff-line saved",
                          class: { "ff-line-returned": _vm.isReturned(it) },
                        },
                        [
                          _c("div", { staticClass: "fl-main" }, [
                            _c(
                              "div",
                              { staticClass: "fl-name" },
                              [
                                _vm._v(
                                  _vm._s(it.material_name) +
                                    "\n                "
                                ),
                                _vm.isReturned(it)
                                  ? _c(
                                      "a-tag",
                                      {
                                        staticClass: "fl-returned-tag",
                                        attrs: {
                                          color: "red",
                                          title: it.return_reason || "",
                                        },
                                      },
                                      [_vm._v("已退")]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                            _vm.optionsText(it.options_json)
                              ? _c("div", { staticClass: "fl-sub" }, [
                                  _vm._v(
                                    _vm._s(_vm.optionsText(it.options_json))
                                  ),
                                ])
                              : _vm._e(),
                            it.remark
                              ? _c("div", { staticClass: "fl-sub" }, [
                                  _vm._v("备注：" + _vm._s(it.remark)),
                                ])
                              : _vm._e(),
                          ]),
                          _c(
                            "div",
                            { staticClass: "fl-right" },
                            [
                              _c("div", { staticClass: "fl-qty" }, [
                                _vm._v("×" + _vm._s(it.quantity)),
                              ]),
                              _c("div", { staticClass: "fl-amount" }, [
                                _vm._v("¥" + _vm._s(_vm.fmt(it.all_price))),
                              ]),
                              !_vm.isReturned(it)
                                ? _c(
                                    "a-button",
                                    {
                                      staticClass: "fl-return-btn",
                                      attrs: {
                                        size: "small",
                                        type: "danger",
                                        ghost: "",
                                        icon: "rollback",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.openReturnModal(it)
                                        },
                                      },
                                    },
                                    [_vm._v("退菜")]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ]
                      )
                    }),
                  ]
                : _vm._e(),
              _vm.cart.length
                ? [
                    _c("div", { staticClass: "ff-group-label" }, [
                      _vm._v("待下单（价格为参考价）"),
                    ]),
                    _vm._l(_vm.cart, function (line, idx) {
                      return _c(
                        "div",
                        { key: line.key, staticClass: "ff-line" },
                        [
                          _c("div", { staticClass: "fl-main" }, [
                            _c("div", { staticClass: "fl-name" }, [
                              _vm._v(_vm._s(line.materialName)),
                            ]),
                            line.optionText
                              ? _c("div", { staticClass: "fl-sub" }, [
                                  _vm._v(_vm._s(line.optionText)),
                                ])
                              : _vm._e(),
                            line.remark
                              ? _c("div", { staticClass: "fl-sub" }, [
                                  _vm._v("备注：" + _vm._s(line.remark)),
                                ])
                              : _vm._e(),
                            _c(
                              "div",
                              { staticClass: "qty-step" },
                              [
                                _c(
                                  "a-button",
                                  {
                                    attrs: { size: "small" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.decQty(idx)
                                      },
                                    },
                                  },
                                  [_vm._v("-")]
                                ),
                                _c("span", { staticClass: "qty-num" }, [
                                  _vm._v(_vm._s(line.quantity)),
                                ]),
                                _c(
                                  "a-button",
                                  {
                                    attrs: { size: "small" },
                                    on: {
                                      click: function ($event) {
                                        line.quantity++
                                      },
                                    },
                                  },
                                  [_vm._v("+")]
                                ),
                                _c("a-button", {
                                  staticClass: "fl-del",
                                  attrs: {
                                    size: "small",
                                    type: "danger",
                                    icon: "close",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.cart.splice(idx, 1)
                                    },
                                  },
                                }),
                              ],
                              1
                            ),
                          ]),
                          _c("div", { staticClass: "fl-right" }, [
                            _c("div", { staticClass: "fl-amount" }, [
                              _vm._v(
                                "¥" +
                                  _vm._s(_vm.fmt(line.unitRef * line.quantity))
                              ),
                            ]),
                          ]),
                        ]
                      )
                    }),
                  ]
                : _vm._e(),
              !_vm.orderItems.length && !_vm.cart.length
                ? _c("div", { staticClass: "ff-cart-empty" }, [
                    _vm._v("点击左侧菜品开始开单"),
                  ])
                : _vm._e(),
            ],
            2
          ),
          _c("div", { staticClass: "ff-footer" }, [
            _c(
              "div",
              { staticClass: "ff-out-row" },
              [
                _c(
                  "a-radio-group",
                  {
                    attrs: { disabled: !!_vm.orderId },
                    model: {
                      value: _vm.isOut,
                      callback: function ($$v) {
                        _vm.isOut = $$v
                      },
                      expression: "isOut",
                    },
                  },
                  [
                    _c("a-radio", { attrs: { value: "1" } }, [
                      _vm._v("店内就餐"),
                    ]),
                    _c("a-radio", { attrs: { value: "2" } }, [
                      _vm._v("打包带走"),
                    ]),
                  ],
                  1
                ),
                _vm.orderId
                  ? _c("span", { staticClass: "ff-out-tip" }, [
                      _vm._v("已下单后消费方式不可更改"),
                    ])
                  : _vm._e(),
              ],
              1
            ),
            _c("div", { staticClass: "ff-fee-row" }, [
              _c("span", [_vm._v("商品合计")]),
              _c("span", [_vm._v("¥" + _vm._s(_vm.fmt(_vm.itemsTotal)))]),
            ]),
            _vm.isOut === "2"
              ? _c("div", { staticClass: "ff-fee-row" }, [
                  _c("span", [_vm._v("打包费" + _vm._s(_vm.boxTypeHint))]),
                  _c("span", [_vm._v("¥" + _vm._s(_vm.fmt(_vm.boxFee)))]),
                ])
              : _vm._e(),
            _c("div", { staticClass: "ff-fee-row ff-total" }, [
              _c("span", [_vm._v("合计")]),
              _c("span", { staticClass: "ff-total-num" }, [
                _vm._v("¥" + _vm._s(_vm.fmt(_vm.orderTotal))),
              ]),
            ]),
            _c(
              "div",
              { staticClass: "ff-actions" },
              [
                _c(
                  "a-button",
                  {
                    attrs: { disabled: !_vm.orderId || _vm.acting },
                    on: { click: _vm.handleVoid },
                  },
                  [_vm._v("作废")]
                ),
                _c(
                  "a-button",
                  {
                    attrs: {
                      disabled: !_vm.canPark || _vm.acting,
                      loading: _vm.acting && _vm.parking,
                    },
                    on: { click: _vm.handlePark },
                  },
                  [_vm._v("挂单")]
                ),
                _c(
                  "a-button",
                  {
                    staticClass: "ff-settle-btn",
                    attrs: {
                      type: "primary",
                      disabled: !_vm.canSettle || _vm.acting,
                      loading: _vm.acting && !_vm.parking,
                    },
                    on: { click: _vm.handleSettle },
                  },
                  [_vm._v("结算")]
                ),
              ],
              1
            ),
          ]),
        ]),
      ]),
      _c("GoodsOptionsModal", {
        attrs: { visible: _vm.modalVisible, goods: _vm.modalGoods },
        on: {
          confirm: _vm.onModalConfirm,
          cancel: function ($event) {
            _vm.modalVisible = false
          },
        },
      }),
      _c(
        "a-modal",
        {
          attrs: {
            title: "结算",
            visible: _vm.settleVisible,
            maskClosable: false,
            width: "480px",
            footer: null,
          },
          on: {
            cancel: function ($event) {
              _vm.settleVisible = false
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "st-body" },
            [
              _vm.order
                ? _c("div", { staticClass: "st-amounts" }, [
                    _c("div", { staticClass: "st-row" }, [
                      _c("span", [_vm._v("商品合计")]),
                      _c("span", [
                        _vm._v("¥" + _vm._s(_vm.fmt(_vm.order.total_amount))),
                      ]),
                    ]),
                    Number(_vm.order.service_money) > 0
                      ? _c("div", { staticClass: "st-row" }, [
                          _c("span", [_vm._v("服务费")]),
                          _c("span", [
                            _vm._v(
                              "¥" + _vm._s(_vm.fmt(_vm.order.service_money))
                            ),
                          ]),
                        ])
                      : _vm._e(),
                    Number(_vm.order.tableware_money) > 0
                      ? _c("div", { staticClass: "st-row" }, [
                          _c("span", [_vm._v("打包费")]),
                          _c("span", [
                            _vm._v(
                              "¥" + _vm._s(_vm.fmt(_vm.order.tableware_money))
                            ),
                          ]),
                        ])
                      : _vm._e(),
                    _c("div", { staticClass: "st-row" }, [
                      _c("span", [_vm._v("应收")]),
                      _c("span", { staticClass: "st-payable" }, [
                        _vm._v("¥" + _vm._s(_vm.fmt(_vm.payablePreview))),
                      ]),
                    ]),
                  ])
                : _vm._e(),
              _c("div", { staticClass: "st-sec-title" }, [_vm._v("会员")]),
              _vm.member
                ? _c(
                    "div",
                    { staticClass: "st-member" },
                    [
                      _c("span", { staticClass: "st-member-name" }, [
                        _vm._v(_vm._s(_vm.member.contacts || "会员")),
                      ]),
                      _c("span", { staticClass: "st-member-phone" }, [
                        _vm._v(_vm._s(_vm.member.telephone || "")),
                      ]),
                      _c(
                        "a-button",
                        {
                          attrs: { size: "small" },
                          on: { click: _vm.clearMember },
                        },
                        [_vm._v("清除")]
                      ),
                    ],
                    1
                  )
                : [
                    _c(
                      "div",
                      { staticClass: "st-member-search" },
                      [
                        _c("a-input", {
                          attrs: {
                            placeholder: "手机号 / 姓名 / 卡号 / 会员码",
                          },
                          on: { pressEnter: _vm.searchMember },
                          model: {
                            value: _vm.memberKeyword,
                            callback: function ($$v) {
                              _vm.memberKeyword = $$v
                            },
                            expression: "memberKeyword",
                          },
                        }),
                        _c(
                          "a-button",
                          {
                            attrs: { loading: _vm.memberSearching },
                            on: { click: _vm.searchMember },
                          },
                          [_vm._v("查询")]
                        ),
                      ],
                      1
                    ),
                    _vm.memberResults.length
                      ? _c(
                          "div",
                          { staticClass: "st-member-results" },
                          _vm._l(_vm.memberResults, function (m) {
                            return _c(
                              "div",
                              {
                                key: m.memberId,
                                staticClass: "st-member-item",
                                on: {
                                  click: function ($event) {
                                    return _vm.pickMember(m)
                                  },
                                },
                              },
                              [
                                _c("span", { staticClass: "smi-name" }, [
                                  _vm._v(_vm._s(m.contacts || m.cardNo)),
                                ]),
                                _c("span", { staticClass: "smi-phone" }, [
                                  _vm._v(_vm._s(m.telephone || "")),
                                ]),
                                m.levelName
                                  ? _c("a-tag", { attrs: { color: "blue" } }, [
                                      _vm._v(_vm._s(m.levelName)),
                                    ])
                                  : _vm._e(),
                              ],
                              1
                            )
                          }),
                          0
                        )
                      : _vm._e(),
                    _c("div", { staticClass: "st-tip" }, [
                      _vm._v("会员价优惠由后端结算时计算"),
                    ]),
                  ],
              _c("div", { staticClass: "st-sec-title" }, [_vm._v("抹零")]),
              _c("a-input-number", {
                staticStyle: { width: "160px" },
                attrs: { min: 0, max: _vm.eraseMax, precision: 2 },
                model: {
                  value: _vm.eraseAmount,
                  callback: function ($$v) {
                    _vm.eraseAmount = $$v
                  },
                  expression: "eraseAmount",
                },
              }),
              _c("div", { staticClass: "st-sec-title" }, [_vm._v("支付方式")]),
              _c("div", { staticClass: "st-pay-types" }, [
                _c(
                  "div",
                  {
                    staticClass: "st-pay-type",
                    class: { active: _vm.payType === "cash" },
                    on: {
                      click: function ($event) {
                        return _vm.switchPayType("cash")
                      },
                    },
                  },
                  [_vm._v("现金")]
                ),
                _c(
                  "div",
                  {
                    staticClass: "st-pay-type",
                    class: { active: _vm.payType === "wx" },
                    on: {
                      click: function ($event) {
                        return _vm.switchPayType("wx")
                      },
                    },
                  },
                  [_vm._v("微信扫码枪")]
                ),
                _c(
                  "div",
                  {
                    staticClass: "st-pay-type",
                    class: { active: _vm.payType === "ali" },
                    on: {
                      click: function ($event) {
                        return _vm.switchPayType("ali")
                      },
                    },
                  },
                  [_vm._v("支付宝扫码枪")]
                ),
              ]),
              _vm.payType !== "cash"
                ? [
                    _c("a-input", {
                      attrs: {
                        placeholder: "扫码枪录入顾客付款码，扫描后自动结算",
                        disabled: _vm.settling,
                      },
                      on: { pressEnter: _vm.confirmSettle },
                      model: {
                        value: _vm.authCode,
                        callback: function ($$v) {
                          _vm.authCode = $$v
                        },
                        expression: "authCode",
                      },
                    }),
                  ]
                : _vm._e(),
              _c(
                "a-button",
                {
                  staticClass: "st-confirm",
                  attrs: {
                    type: "primary",
                    size: "large",
                    block: "",
                    loading: _vm.settling,
                  },
                  on: { click: _vm.confirmSettle },
                },
                [_vm._v("确认结算")]
              ),
            ],
            2
          ),
        ]
      ),
      _c(
        "a-modal",
        {
          attrs: {
            visible: _vm.callVisible,
            footer: null,
            maskClosable: false,
            centered: "",
          },
          on: {
            cancel: function ($event) {
              _vm.callVisible = false
            },
          },
        },
        [
          _vm.settleResult
            ? _c(
                "div",
                { staticClass: "callno-wrap" },
                [
                  _c("div", { staticClass: "callno-label" }, [
                    _vm._v("结算成功，取餐号"),
                  ]),
                  _c("div", { staticClass: "callno-num" }, [
                    _vm._v(_vm._s(_vm.settleResult.callNo || "—")),
                  ]),
                  _c("div", { staticClass: "callno-sub" }, [
                    _vm._v(
                      "\n        实收 ¥" +
                        _vm._s(_vm.fmt(_vm.settleResult.payAmount)) +
                        "（" +
                        _vm._s(_vm.payText(_vm.settleResult.payType)) +
                        "）\n      "
                    ),
                  ]),
                  _c(
                    "a-button",
                    {
                      attrs: { type: "primary", size: "large", block: "" },
                      on: {
                        click: function ($event) {
                          _vm.callVisible = false
                        },
                      },
                    },
                    [_vm._v("完成")]
                  ),
                ],
                1
              )
            : _vm._e(),
        ]
      ),
      _c("return-item-modal", {
        attrs: {
          visible: _vm.returnVisible,
          "item-name": _vm.returnTarget ? _vm.returnTarget.material_name : "",
          loading: _vm.returnLoading,
        },
        on: {
          cancel: function ($event) {
            _vm.returnVisible = false
          },
          confirm: _vm.confirmReturn,
        },
      }),
      _c("print-modal", { ref: "printModal" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }